<template>
  <div>
    <v-container fluid id="crm">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <h5>Difficulty levels results</h5>
        </v-flex>
        <v-flex xs12 sm6>
          <v-layout row wrap justify-end>
            <v-select
              :items="chaptherList"
              style="max-width: 300px"
              label="Search"
              solo
              @change="fetchCountLevel"
              v-model="selectedChap"
            ></v-select>
          </v-layout>
        </v-flex>
      </v-layout>
      <div id="chart" style="width: 100%">
        <apexchart
          ref="satisfication"
          type="donut"
          height="500"
          :options="chartOptions"
          :series="series"
          :key="chartKey"
          style="margin-bottom: 100px"
        ></apexchart>
      </div>
      <v-layout v-if="rawCountdata" row wrap justify-space-between>
        <v-flex xs12 sm3 class="box py-3" @click="showUser('E')">
          <v-layout column>
            <div>Encourage</div>
            <div>{{ rawCountdata.encourage }}</div>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm3 class="box py-3" @click="showUser('N')">
          <v-layout column>
            <div>Standard</div>
            <div>{{ rawCountdata.standard }}</div>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm3 class="box py-3" @click="showUser('H')">
          <v-layout column>
            <div>Challenge</div>
            <div>{{ rawCountdata.challenge }}</div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showUserList" persistent max-width="800" scrollable>
      <v-card class="py-4">
        <v-layout class="mx-2" column justify-center align-center align-content-center>
          <v-layout row wrap style="width: 100%" justify-center align-end align-content-center>
            <v-flex xs12 sm5 class="form-control pr-1">
              <label for>Name</label>
              <input
                type="text"
                placeholder="Name"
                v-model.lazy="filter.name"
                class="form-control my-0"
                maxlength="255"
              />
            </v-flex>
            <v-flex xs12 sm5 class="pr-1">
              <label for>Age</label>
              <multiselect
                v-model="filter.age"
                :options="ageOption"
                name="age"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
              ></multiselect>
            </v-flex>
            <v-flex xs12 sm2 style="padding-bottom: 4px">
              <v-btn @click="searchFilter" class="my-0 mx-0" color="primary">{{
                $t('search')
              }}</v-btn>
            </v-flex>
          </v-layout>
          <v-data-table
            style="width: 100%"
            :headers="headers"
            :items="showUserData"
            :loading="loading"
            class="elevation-1"
            hideActions
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ props.item.name }}</td>
                <td style="width: 150px">{{ props.item.age }}</td>
              </tr>
            </template>

            <div class="text-xs-center" slot="no-data">{{ $t('No data') }}</div>
          </v-data-table>
          <v-flex xsauto>
            <v-pagination
              class="mt-4"
              @input="changepage"
              v-model="userPage"
              :length="pageCount"
              :total-visible="10"
            ></v-pagination>
          </v-flex>
          <v-flex xsauto>
            <v-btn
              @click="closeShowUser"
              color="gray"
              class="mt-4"
              style="width: max-content"
              outline
              >CLOSE</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import atomicboyApi from '@/api/atomicboy'
import VueApexCharts from 'vue-apexcharts'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
    apexchart: VueApexCharts
  },
  data() {
    return {
      headers: [
        { text: 'Name', sortable: false },
        { text: 'Age', sortable: false }
      ],
      filter: {
        name: null,
        age: null
      },
      ageOption: ['18-24 ปี', '25-34 ปี', '35-44 ปี', '45-54 ปี', '55-64 ปี', '65 ปีขึ้นไป'],
      showUserList: false,
      activeLevel: null,
      userPage: 1,
      total: 0,
      rowPerPage: 10,
      loading: false,
      chaptherList: [
        'All',
        '11-1',
        '11-2',
        '11-3',
        '11-4',
        '11-5',
        '11-6',
        '11-7',
        '11-8',
        '11-9',
        '11-10',
        '11-11',
        '11-12',
        '11-13',
        '11-14',
        '12-1',
        '12-2',
        '12-3',
        '12-4',
        '12-5',
        '12-6',
        '12-7',
        '13-1',
        '13-2',
        '13-3',
        '13-4',
        '13-5'
      ],
      selectedChap: 'All',
      rawCountdata: null,
      chartKey: 0,
      showUserData: [],
      series: [],
      chartOptions: {
        states: {
          hover: 1
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          show: true
        },
        grid: {
          show: true
        },
        tooltip: {
          enabled: true
        },
        dropShadow: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'right',
          horizontalAlign: 'center',
          width: 180,
          height: 230,
          offsetY: 20,
          floating: true,
          fontSize: '16px',
          fontFamily: 'Helvetica, Arial'
        },
        chart: {
          width: '100%',
          type: 'donut'
        },
        labels: []
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageCount() {
      if (this.total) {
        return Math.ceil(this.total / this.rowPerPage)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.fetchCountLevel()
  },
  methods: {
    closeShowUser() {
      this.showUserData = []
      this.showUserList = 0
      this.filter = {
        name: null,
        age: null
      }
    },
    searchFilter() {
      this.userPage = 1
      this.fetchUserListByLevel()
    },
    changepage() {
      this.fetchUserListByLevel()
    },
    showUser(level) {
      this.showUserList = true
      this.activeLevel = level
      this.userPage = 1
      this.fetchUserListByLevel()
    },
    async fetchCountLevel() {
      try {
        let countdata = await atomicboyApi.countUserLevel(this.selectedChap)
        if (countdata && countdata.data && countdata.data.data) {
          this.rawCountdata = countdata.data.data
          this.setChartData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchUserListByLevel() {
      this.loading = true

      let body = {
        pageid: this.selectedBot.pageid,
        level: this.activeLevel,
        limit: this.rowPerPage,
        offset: this.rowPerPage * this.userPage - this.rowPerPage,
        ...this.filter
      }
      if (this.selectedChap.toLowerCase() != 'all') {
        body.chapter = this.selectedChap
      }
      let userData = await atomicboyApi.userListByLevel(body)
      try {
        if (userData && userData.data) {
          userData = userData.data
          this.showUserData = userData.data
          this.total = userData.total
        } else {
          throw 'No data return'
        }
      } catch (error) {
        this.showUserData = []
        this.total = 0
      }
      this.loading = false
    },
    setChartData() {
      let vm = this
      this.chartKey++
      this.series = []
      vm.chartOptions.labels = []
      const chatData = this.rawCountdata
      let sum = 0
      for (const key in chatData) {
        if (!chatData[key]) {
          chatData[key] = 0
        }
        sum += parseFloat(chatData[key])
      }
      let empty = 0
      for (const key in chatData) {
        if (chatData[key] || chatData[key] == 0) {
          if (chatData[key] == 0) {
            vm.series.push(0)
            empty++
          } else {
            vm.series.push(parseFloat(((chatData[key] / sum) * 100).toFixed(2)))
          }
          const keyTemp =
            key == 'encourage'
              ? 'Encourage'
              : key == 'standard'
              ? 'Standard'
              : key == 'challenge'
              ? 'Challenge'
              : key
          vm.chartOptions.labels.push(keyTemp)
        }
      }
      vm.chartOptions.legend.show = true
      vm.chartOptions.dropShadow.enabled = true
      vm.chartOptions.tooltip.enabled = true
      vm.chartOptions.stroke.show = true
      vm.chartOptions.grid.show = true
      vm.chartOptions.dataLabels.enabled = true
      delete vm.chartOptions.colors
      delete vm.chartOptions.states
      delete vm.chartOptions.plotOptions

      if (empty == 3) {
        vm.series = [100]
        vm.chartOptions.labels = ['empty']
        vm.chartOptions.tooltip.enabled = false
        vm.chartOptions.stroke.show = false
        vm.chartOptions.grid.show = false
        vm.chartOptions.dropShadow.enabled = false
        vm.chartOptions.dataLabels.enabled = false
        vm.chartOptions.legend.show = false
        vm.chartOptions = {
          ...vm.chartOptions,
          colors: ['#d5d5d5'],
          states: {
            hover: 1
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: 'No Data',
                    color: '#a5a5a5',
                    formatter: function (w) {
                      return ''
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>
<style>
.box {
  margin-top: 5px;
  background: #f7856a;
  border: 2px solid #ffffff;
  border-radius: 10px;
  color: white;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}
.v-card {
  height: max-content !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AtomicboyGameLevelReport.vue